<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="基础信息管理" v-if="p('project/list')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="功能区管理" v-if="p('functionalarea/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="房源管理" v-if="p('houseInfo/list')">
        <c3></c3>
      </TabPane>
      <TabPane name="4" label="基础规则" v-if="p('baseRule/getBaseRule')">
        <c4></c4>
      </TabPane>
      <TabPane name="5" label="服务费折扣规则" v-if="p('serviceFeeDiscountRule/getServiceFeeDiscountRule')">
        <c5></c5>
      </TabPane>
      <TabPane name="6" label="项目结算管理" v-if="p('proprietor/getPropBalConfigList')">
        <c6></c6>
      </TabPane>
      <TabPane name="7" label="业主信息管理" v-if="p('owner/list')">
        <c7></c7>
      </TabPane>
      <TabPane name="8" label="理房通商户管理" v-if="p('merchant/list')">
        <c8></c8>
      </TabPane>
      <TabPane name="9" label="生活费用管理" v-if="p('waterwatt/standard/list')">
        <c9></c9>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/products/project/index'
  import C2 from '@/views/products/ribbon/index'
  import C3 from '@/views/products/house/inventory/index'
  import C4 from '@/views/managementCenter/basicRules/index'
  import C5 from '@/views/managementCenter/serviceChargeRules/index'
  import C6 from '@/views/projectSettlement/index'
  import C7 from '@/views/products/proManage/index'
  import C8 from './lifangtong/index'
  import C9 from '@/views/smartPower/waterAndElectricity/index'
  import {mixin} from "../../mixin";


  export default {
    name:'projects',
    mixins:[mixin],
    components:{
      C1,
      C2,
      C3,
      C4,
      C5,
      C6,
      C7,
      C8,
      C9,
    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
